import { print } from 'graphql'
import { Cart } from 'shopify-types'

import { storefrontClient } from '..'
import { UpdateCartLinesDocument, type UpdateCartLinesMutation } from '../__generated/storefront'
import { GlobalRequestOptions } from '../types'
import { mapGQLCartToCart } from './graphql'

type UpdateCartLineInput = Readonly<{
  id: string
  merchandiseId?: string
  quantity?: number
}>[]

export const updateCartLine =
  (options: GlobalRequestOptions) =>
  async (cartId: string, lines: UpdateCartLineInput): Promise<Cart> => {
    const response = await storefrontClient.request<UpdateCartLinesMutation>(
      print(UpdateCartLinesDocument),
      {
        variables: {
          cartId,
          lines,
          language: options.language,
        },
      },
    )

    const payload = response.data?.cartLinesUpdate

    if (!payload?.cart) {
      throw new Error('Failed to update line item')
    }

    return mapGQLCartToCart(payload.cart)
  }
